import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Button, FormFeedback } from "reactstrap";
import Select from "react-select";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { formatCurrency, formatDate } from '../../Utils/formatters';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const DividendTransactions = props => {
  const [modal_Fiat_Transaction, setmodal_Fiat_Transaction] = useState(false);
  function Fiat_Transaction() {
    setmodal_Fiat_Transaction(!modal_Fiat_Transaction);
  }


  //meta title
  document.title = "Dividend Transactions";
  const { getRequest, postRequest } = useRequests();
  
  
  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      user: {label: 'All', value: 'All'},
      status: 'All',
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = TransactionData;
        if(values.user.value !== 'All') {
          filteredData = filteredData.filter(item => String(item.u_id) === String(values.user.value));
        }
        if(values.status !== 'All') {
          filteredData = filteredData.filter(item => item.status === values.status);
        }

        if(filteredData.length > 0) {
          handleT1Body(filteredData);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="11" className="text-center">No records found</td>
                        </tr>);

          setTransactionTBody(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [Transaction, setTransaction] = React.useState([]);
  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    setTransaction(elementData);
    setStandardModal1(true);
  }

  const [TransactionData, setTransactionData] = React.useState([]);
  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{formatDate(element.record_date)}</td>
        <td>{formatDate(element.payment_date)}</td>
        <td>{element.number_of_token}</td>
        <td>{formatCurrency(element.dividend_amount)}</td>
        {element.paid_amount !== null?
          <td>{element.paid_amount} &nbsp;{element.paid_amount_currency}</td>
        : <td>-</td> }
        <td>{element.payment_method}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-secondary')}>{element.status}</span></td>
        {element.payment_detail !== null?
          <td style={{ whiteSpace: 'pre-line' }}>{element.payment_detail}</td>
        : <td>-</td> }
        <td className="text-center">
          <div className="centerLink">
            <span className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal1(element)}><i className="mdi mdi-eye"></i></span>
          </div>
        </td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  const handleLoadGetTransactionData = async () => {
    const res = await getRequest('get-dividend-transaction-data');
    if (res && res.code === 200) {
      handleT1Body(res.data);
      setTransactionData(res.data);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="11" className="text-center">No records found</td>
                      </tr>);

      setTransactionTBody(tempTBody);
    }
  }
  
  const [UsersData, setUsersData] = React.useState([]);
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let tempArr = [{label: 'All', value: 'All'}];
      res.data.forEach(element => {
        let temp = {
            label: `${element.first_name} ${element.last_name} (${element.email})`,
            value: element.u_id,
        };
        tempArr.push(temp);
      });
      if (props.match.params.id) {
        let getUser = tempArr.find(element => String(element.value) === String(atob(props.match.params.id)));
        
        validation1.setValues({
          ...validation1.values,
          user: getUser,
        });

        setTimeout(() => {
          validation1.handleSubmit();
        }, 500);
      }
      tempArr = [{
          options: tempArr
      }];
      setUsersData(tempArr);
    }
  }
  React.useEffect(() => {
    handleLoadGetTransactionData();
    handleLoadGetUsers();
  }, []);

 
  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Dividend Transactions")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col md={4} xs={12}>
                        <div className="mb-3 Register-Select2">
                          <label className="form-label">Users : </label>
                          <Select styles={colourStyles} value={validation1.values.user} onChange={(e) => validation1.setValues({ ...validation1.values, user: e })} options={UsersData} classNamePrefix="select2-selection" />
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Status : </label>
                          <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Approved'}>Approved</option>
                            <option value={'Cancelled'}>Cancelled</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label fullWidth">&nbsp; </label>
                          <Button type="button" 
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                          color="primary">Search</Button>
                        </div>
                      </Col>
                    </div>
                    <div className="table-responsive mb-0 mt-3" data-pattern="priority-columns">
                      <table className="table mb-0" style={{ minWidth: '1900px' }}>
                        <thead className="table-light">
                          <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Record Date</th>
                            <th>Payment Date</th>
                            <th>Number of Token</th>
                            <th>Dividend Amount</th>
                            <th>Amount to be Paid</th>
                            <th>Payment Method</th>
                            <th>Status</th>
                            <th>Payment Detail</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {TransactionTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Fiat Transaction Modal */}

          <Modal isOpen={modal_Fiat_Transaction} toggle={() => { Fiat_Transaction(); }} backdrop={'static'} centered className="transation" size="lg">
            <div className="modal-header">
              <h5 className="modal-title mt-0">Payment Reference</h5>
              <button type="button" onClick={() => { setmodal_Fiat_Transaction(false); }} className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mb-3">
              <div className="row">
                <div className="col-lg-6">
                  <p className="mb-1 border-box-1"><b>First Name :</b> <span className="">Kaushal</span></p>
                  <p className="mb-1 border-box-1"><b>Last Name :</b> <span className="">Sadhu</span></p>
                  <p className="mb-1 border-box-1"><b>Record Date :</b> <span className="">16/11/2023 | 15:30</span></p>
                  <p className="mb-1 border-box-1"><b>Payment Date :</b> <span className="">16/11/2023 | 15:30</span></p>
                  <p className="mb-1 border-box-1"><b>Number of Token :</b> <span className="">1</span></p>
                  <p className="mb-1 border-box-1"><b>Dividend Amount :</b> <span className="">5,00 €</span></p>
                  <p className="mb-1 border-box-1"><b>Amount to be Paid :</b> <span className="">50,00 €</span></p>
                  <p className="mb-1 border-box-1"><b>Payment Method :</b> <span className="">Wire Transfer Euro</span></p>
                </div>
                <div className="col-lg-6">
                  <p className="mb-1 border-box-1"><b>Payment Detail :</b></p>
                  <p className="mb-1">Account Holder Name : Kaushal Sadhu <br /> IBAN No. : 56974562211 <br /> Routing No. : 1236644 <br /> BIC Code : BIC236544</p>
                  <p className="mb-2 border-box-1 mt-4"><b>Payment Reference :</b></p>
                  <p className="mb-1"><span>Bank of america transaction id #123665266 Payment transferred</span></p>
                </div>
              </div>
            </div>
          </Modal>


          {/* Crypto Transaction Modal */}

          <Modal isOpen={StandardModal1} backdrop={'static'} centered className="transation" size="lg">
            <div className="modal-header">
              <h5 className="modal-title mt-0">Payment Reference</h5>
              <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mb-3">
              <div className="row">
                <div className="col-lg-6">
                  <p className="mb-1 border-box-1"><b>First Name :</b> <span className="">{Transaction.first_name}</span></p>
                  <p className="mb-1 border-box-1"><b>Last Name :</b> <span className="">{Transaction.last_name}</span></p>
                  <p className="mb-1 border-box-1"><b>Record Date :</b> <span className="">{formatDate(Transaction.record_date)}</span></p>
                  <p className="mb-1 border-box-1"><b>Payment Date :</b> <span className="">{formatDate(Transaction.payment_date)}</span></p>
                  <p className="mb-1 border-box-1"><b>Number of Token :</b> <span className="">{Transaction.number_of_token}</span></p>
                  <p className="mb-1 border-box-1"><b>Dividend Amount :</b> <span className="">{formatCurrency(Transaction.dividend_amount)}</span></p>
                  <p className="mb-1 border-box-1"><b>Amount to be Paid :</b> <span className="">{Transaction.paid_amount !== null? `${Transaction.paid_amount} ${Transaction.paid_amount_currency}` : 'N/A'}</span></p>
                  <p className="mb-1 border-box-1"><b>Payment Method :</b> <span className="">{Transaction.payment_method}</span></p>
                </div>
                <div className="col-lg-6">
                  <p className="mb-1 border-box-1"><b>Payment Detail :</b></p>
                  <p className="mb-1" style={{ whiteSpace: 'pre-line' }}>{Transaction.payment_detail !== null? Transaction.payment_detail : 'N/A'}</p>
                  <p className="mb-2 border-box-1 mt-4"><b>Payment Reference :</b></p>
                  <p className="mb-1"><span>{Transaction.payment_reference !== null? Transaction.payment_reference : 'N/A'}</span></p>
                </div>
              </div>
            </div>
          </Modal>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default withTranslation()(DividendTransactions);
